import React, { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";

import { IndexContext } from "../../components/layout/Layout";
import styles from "./DashboardStatics.module.scss";
import Chart from "react-apexcharts";

function BarModal(props) {
  //-------------------------------------------IndexContext
  const IndexProvider = useContext(IndexContext);
  let PIS = IndexProvider.indexStyle;
  //-------------------------------------------IndexContext
  const [loadingTable, setLoadingTable] = useState(false);

  const handleClose = () => {
    props.setAskQueryModal(false);
    props.setSelectedData(null);
  };

  useEffect(() => {
    setLoadingTable(true);
    // console.log(props.selectedSlice);
  }, [props.selectedSlice]);

  useEffect(() => {
    // console.log(props.selectedData);
  }, [props.selectedData]);
  //---------------------------------------------------

  //---------------------------------------------------
  const options = {
    chart: {
      type: "bar",
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: (value) => value.toFixed(0), // Remove decimals
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: props.stacked ? "35%" : "15%", // Adjusts the thickness of the bars
        borderRadius: 8, // Fully rounded bars
      },
    },
    colors: props.colors, // Custom colors for each series
    dataLabels: {
      enabled: true,
      formatter: function (val, opts) {
        // Calculate percentage relative to the total value of the series
        const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
        const per = props.percentage ? val + "%" : val;
        return per; // Show percentage on bars
      },
      style: {
        fontSize: "12px",
        colors: props.stacked ? ["#141814"] : ["#FFF"],
      },
    },
    xaxis: {
      categories: [props.selectedSlice],
    },
  };

  return (
    <Modal
      animation
      centered
      show
      onHide={handleClose}
      size="lg"
      dialogClassName="custom-modal"
    >
      <Modal.Header
        className="p-4 pb-0 fw-bold"
        closeButton
        style={{ borderRadius: "20px" }}
      >
        <h4>{props.selectedSlice}</h4>
      </Modal.Header>
      <Modal.Body className="px-4">
        <div className="d-flex flex-column align-items-center w-100">
          <div className="w-100 row">
            <div className={` ${props.askQueryModal ? styles.show : ""} `}>
              <Chart
                options={options}
                series={props.selectedData}
                type="bar"
                height={600}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default BarModal;
